import React, {useContext, useState} from "react"
import PropTypes from "prop-types"
import ShelfApi from "~/utils/ShelfApi.js"
import TextField from "@material-ui/core/TextField"
import Box from "@material-ui/core/Box"
import Button from "~/components/Button"
import {useDebouncedValue} from "../../hooks"
import {LoadingIndicator} from "~/components/"
import {ShoppingCartContext} from "../../context/ShoppingCartContext"
import {useTranslation} from "react-i18next"

export const OrderProductBox = ({product}) => {
  const {t} = useTranslation()
  const [quantity, setQuantity] = useState(1)
  const [loading, setLoading] = useState(false)
  const [statusText, setStatusText] = useState("")

  const handleQuantity = value => {
    if (isNaN(parseInt(value)) || parseInt(value) < 1) {
      setQuantity(1)
    } else {
      setQuantity(parseInt(value))
    }
  }

  const {updateShoppingCart} = useContext(ShoppingCartContext)

  const reorder = () => {
    if (loading) return
    setLoading(true)
    setStatusText("")

    const product_id = product.id

    ShelfApi.postV2(`product_in_carts`, {quantity, product_id})
      .then(res => {
        setStatusText(
          `${quantity} Stück erfolgreich zum Warenkorb hinzugefügt.`
        )
        setQuantity(1)
        updateShoppingCart()
      })
      .catch(e => {
        setStatusText("Bestellung fehlgeschlagen!")
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Box flexDirection="row" display="flex" alignItems="center">
      <Button
        onClick={() => {
          if (quantity > 1) {
            handleQuantity(quantity - 1)
          }
        }}
        label="–"
        primary
      />
      <TextField
        inputProps={{
          style: {
            padding: 10,
            textAlign: "center"
          }
        }}
        style={{margin: 5, minWidth: 40, maxWidth: 60}}
        value={quantity}
        id="outlined-basic"
        variant="outlined"
        onChange={e => {
          handleQuantity(e.target.value)
        }}
      />

      <Button
        onClick={() => {
          handleQuantity(quantity + 1)
        }}
        label="+"
        primary
      />

      <a className="sh-button sh-button--primary" onClick={reorder}>
        {t("addToCart")}
      </a>
      {statusText && (
        <p style={{fontSize: "1.3em", paddingLeft: 12}}>{statusText}</p>
      )}
      {loading && <LoadingIndicator message={""} />}
    </Box>
  )
}

OrderProductBox.propTypes = {
  product: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/domain/OrderProductBox.js